




































































































import { Component, Vue } from 'vue-property-decorator';
import { changeLoading } from '@/util/plugins';
const { VUE_APP_FCAPI: FCAPI } = process.env;
const API = {
  list: `${FCAPI}/shang/ruan/cases`,
  change_status: `${FCAPI}/shang/ruan/cases/`,
  edit_sort: `${FCAPI}/shang/ruan/cases/sort/`,
  get_list: `${FCAPI}/shang/ruan/style`,
};
const STATUS = [
  {
    value: 0,
    label: '全部',
  },
  {
    value: 1,
    label: '上架中',
  },
  {
    value: 2,
    label: '已下架',
  },
];
const dateFormat = require('bmh/date-format');
function initDesignWorksList(remote?: any) {
  remote = remote || {};
  return {
    current: remote.current || 0,
    detail: remote.detail || [],
    last: remote.last || 0,
    limit: remote.limit || 0,
    total: remote.total || 0,
  };
}
function initFormValue() {
  return {
    name: '',
    tag: '',
    style_id: 0,
    status: 0,
  };
}
const getUrl = require('baimahu/url-with-param');
@Component
export default class DesignWorks extends Vue {
  active_index: number = -1;
  is_loading: boolean = false;
  design_works_list: any = initDesignWorksList();
  form_value: any = initFormValue();
  style_list: any = initDesignWorksList();
  old_value: string = '';
  get status() {
    return STATUS;
  }
  paginationOption(data: any) {
    return {
      showTotal: () => `共${data.total}条，每页${data.limit}条`,
      pageSize: data.limit || 0,
      total: data.total || 0,
      current: data.current || 0,
    };
  }

  dateFormat(time: any) {
    return dateFormat(new Date(time * 1000), '%Y-%m-%d %H:%M:%S');
  }

  // 清空搜索项
  clearForm() {
    this.form_value = initFormValue();
  }

  // 跳转到编辑页面
  edit(record: any) {
    this.$router.push(`/operation/add-design-works?id=${record.id}`);
  }

  // 展示排序输入框
  showInput(record: any, index: number) {
    this.active_index = index;
    this.old_value = record.sort;
  }

  // 关闭排序输入框
  closeInput(record: any) {
    record.sort = this.old_value;
    this.active_index = -1;
  }

  // 获取风格列表
  @changeLoading(['is_loading'])
  async getStyleList(
    query_params: any = {
      current: 1,
    }
  ) {
    const url = getUrl(API.get_list, query_params);
    const res = await this.$axios.get(url);
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.style_list = initDesignWorksList(res.data.data);
    this.style_list.detail.unshift({
      id: 0,
      name: '全部',
    });
  }

  // 编辑排序
  @changeLoading(['is_loading'])
  async edirSort(record: any) {
    const res = await this.$axios.put(`${API.edit_sort}${record.id}`, {
      id: record.id,
      sort: record.sort,
    });
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.active_index = -1;
    await this.getWorkList();
  }

  // 切换分页
  @changeLoading(['is_loading'])
  async handleChange(data: any) {
    const form = this.form_value;
    await this.getWorkList({
      name: form.name,
      tag: form.tag,
      style_id: form.style_id,
      is_show: form.status,
      current: data.current,
    });
  }

  // 切换上下架状态
  @changeLoading(['is_loading'])
  async changeStatus(record: any) {
    const url = getUrl(`${API.change_status}${record.id}/edit`, {
      id: record.id,
      is_show: record.is_show === 1 ? 2 : 1,
    });
    const res = await this.$axios.get(url);
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    await this.getWorkList();
  }

  // 点击搜索按钮
  @changeLoading(['is_loading'])
  async clickSearchBtn() {
    const data = this.form_value;
    await this.getWorkList({
      name: data.name,
      tag: data.tag,
      style_id: data.style_id,
      is_show: data.status,
    });
  }

  // 获取设计作品列表
  @changeLoading(['is_loading'])
  async getWorkList(query_params: any = {}) {
    this.design_works_list = initDesignWorksList();
    const url = getUrl(API.list, query_params);
    const res = await this.$axios.get(url);
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.design_works_list = initDesignWorksList(res.data.data);
  }

  @changeLoading(['is_loading'])
  async created() {
    await this.getStyleList();
    await this.getWorkList();
  }
}
